module.exports = __webpack_public_path__ + "static/ENdeskSlide2-419b8fb0690e011b5c3c6016f3f7fd66.png";